import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";

// Date-only picker (value is "YYYY-MM-DD" or ""), shadcn Calendar in a popover instead of the native browser control.
export const DateField = ({ value, onChange, placeholder = "Pick a date", testid, className = "", fromDate }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  const ok = date && isValid(date);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={`inline-flex items-center gap-2 h-9 rounded-md border border-input bg-card px-3 text-sm text-left hover:border-primary ${ok ? "" : "text-muted-foreground"} ${className}`}>
          <CalendarDays className="h-4 w-4 shrink-0 text-muted-foreground" />
          <span className="flex-1 truncate">{ok ? format(date, "MMM d, yyyy") : placeholder}</span>
          {ok && <span role="button" aria-label="Clear date" data-testid={testid ? `${testid}-clear` : undefined} onClick={(e) => { e.stopPropagation(); onChange(""); }} className="text-muted-foreground hover:text-foreground"><X className="h-3.5 w-3.5" /></span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testid ? `${testid}-popover` : undefined}>
        <Calendar mode="single" selected={ok ? date : undefined} fromDate={fromDate} onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
